import * as React from 'react';
import { createSelectable, TSelectableItemProps } from '../../../../components/drag-select';
import { toLocalDateString, toSlashedShortDate } from '../../../../utils/date-utils';
import { ContainerWithNotifications } from '../../../../transportation/models/communications/container-delivery-schedule';
import { ShipmentStatusMetadata } from '../../../../transportation/models/enums/shipment-status';

// #region Component Props

interface IProps extends TSelectableItemProps {
    container: ContainerWithNotifications;
}

// #endregion

const ContainerCommunicationsRow = (props: IProps) => {

    const { selectableRef,
        isSelected,
        isSelecting
    } = props;

    let actualClass = 'order-selectable';
    actualClass += (props.container.isChecked) ? ' highlight' : '';
    actualClass += (isSelecting) ? ' dragging' : '';
    actualClass += (isSelected) ? ' selected-already' : '';

    return <tr
        ref={selectableRef}
        className={`container-row ${actualClass}`}>
        <td>
            {props.container.id}
        </td>
        <td>
            <span className={"text-uppercase shipment-status-color " + ShipmentStatusMetadata[props.container.status].class}>
                {ShipmentStatusMetadata[props.container.status].display}
            </span>
        </td>
        <td>{props.container.name}</td>
        <td>{props.container.cutoffDate ? toSlashedShortDate(props.container.cutoffDate) : ''}</td>
            <td>{props.container.psSent ? `${toLocalDateString(props.container.psSent, props.container.timeZoneId)}` : ''}</td>
            <td>{props.container.pdSent ? `${toLocalDateString(props.container.pdSent, props.container.timeZoneId)}` : ''}</td>
            <td>{props.container.fdSent ? `${toLocalDateString(props.container.fdSent, props.container.timeZoneId)}` : ''}</td>


    </tr>;
};
 
export default createSelectable(ContainerCommunicationsRow);
